import "./pfaendungsrechner.26cd6fa3.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4b8f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4b8f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $dhiFF = parcelRequire("dhiFF");
/**
 * @param {NodeList} elements
 * @param {string} backgroundColor
 */ function $4e02fd932eca500b$export$398bd3ed8b98188b(elements, backgroundColor) {
    elements.forEach((element)=>{
        element.style.backgroundColor = backgroundColor;
    });
}
/**
 * @param {NodeList} elements
 * @param {string} textColor
 */ function $4e02fd932eca500b$export$f1e4a8e88d67b4ce(elements, textColor) {
    elements.forEach((element)=>{
        element.style.color = textColor;
    });
}
/**
 * @param {URLSearchParams} searchParams
 */ function $4e02fd932eca500b$export$17155d18b588211a(searchParams) {
    if (searchParams.has("backgroundColor")) $4e02fd932eca500b$export$398bd3ed8b98188b(document.querySelectorAll("body"), searchParams.get("backgroundColor"));
    if (searchParams.has("textColor")) $4e02fd932eca500b$export$f1e4a8e88d67b4ce(document.querySelectorAll(".title, .label, .button:not(.is-static), .help, .webmaster, .privacy"), searchParams.get("textColor"));
    if (searchParams.has("buttonBackgroundColor")) $4e02fd932eca500b$export$398bd3ed8b98188b(document.querySelectorAll(".button:not(.is-static)"), searchParams.get("buttonBackgroundColor"));
    if (searchParams.has("buttonTextColor")) $4e02fd932eca500b$export$f1e4a8e88d67b4ce(document.querySelectorAll(".button:not(.is-static)"), searchParams.get("buttonTextColor"));
}


function $71617cddcb043f84$export$2e2bcd8739ae039(wages, people) {
    let start = 126000;
    let addon = 0;
    let index = -1;
    if (wages < 9999) wages *= 100;
    if (people === 1) start = 173000;
    if (people === 2) start = 199000;
    if (people === 3) start = 225000;
    if (people === 4) start = 252000;
    if (people === 5) start = 278000;
    if (wages > 384008) {
        addon = wages - 384008;
        wages = 384008;
    }
    while(wages >= start){
        start += 1000;
        index++;
    }
    if (index === -1) return 0;
    let startAmount = 515;
    let indexAmount = 700;
    if (people === 1) {
        startAmount = 296;
        indexAmount = 500;
    }
    if (people === 2) {
        startAmount = 131;
        indexAmount = 400;
    }
    if (people === 3) {
        startAmount = 19;
        indexAmount = 300;
    }
    if (people === 4) {
        startAmount = 159;
        indexAmount = 200;
    }
    if (people === 5) {
        startAmount = 53;
        indexAmount = 100;
    }
    return startAmount + index * indexAmount + addon;
}


const $f1cf1f81a56d6fb5$export$51ea0f9ef65af7b4 = 407772;
function $f1cf1f81a56d6fb5$export$2e2bcd8739ae039(wages, people) {
    let start = 134000;
    let addon = 0;
    let index = -1;
    if (wages < 9999) wages *= 100;
    if (people === 1) start = 184000;
    if (people === 2) start = 211000;
    if (people === 3) start = 239000;
    if (people === 4) start = 267000;
    if (people === 5) start = 295000;
    if (wages > $f1cf1f81a56d6fb5$export$51ea0f9ef65af7b4) {
        addon = wages - $f1cf1f81a56d6fb5$export$51ea0f9ef65af7b4;
        wages = $f1cf1f81a56d6fb5$export$51ea0f9ef65af7b4;
    }
    while(wages >= start){
        start += 1000;
        index++;
    }
    if (index === -1) return 0;
    let startAmount = 689;
    let indexAmount = 700;
    if (people === 1) {
        startAmount = 461;
        indexAmount = 500;
    }
    if (people === 2) {
        startAmount = 13;
        indexAmount = 400;
    }
    if (people === 3) {
        startAmount = 43;
        indexAmount = 300;
    }
    if (people === 4) {
        startAmount = 50;
        indexAmount = 200;
    }
    if (people === 5) {
        startAmount = 36;
        indexAmount = 100;
    }
    return startAmount + index * indexAmount + addon;
}


const $0299fb0bb1cf39c5$export$51ea0f9ef65af7b4 = 429881;
function $0299fb0bb1cf39c5$export$2e2bcd8739ae039(wages, people) {
    let start = 141000;
    let addon = 0;
    let index = -1;
    if (wages < 9999) wages *= 100;
    if (people === 1) start = 194000;
    if (people === 2) start = 223000;
    if (people === 3) start = 252000;
    if (people === 4) start = 282000;
    if (people === 5) start = 311000;
    if (wages > $0299fb0bb1cf39c5$export$51ea0f9ef65af7b4) {
        addon = wages - $0299fb0bb1cf39c5$export$51ea0f9ef65af7b4;
        wages = $0299fb0bb1cf39c5$export$51ea0f9ef65af7b4;
    }
    while(wages >= start){
        start += 1000;
        index++;
    }
    if (index === -1) return 0;
    let startAmount = 540;
    let indexAmount = 700;
    if (people === 1) {
        startAmount = 498;
        indexAmount = 500;
    }
    if (people === 2) {
        startAmount = 238;
        indexAmount = 400;
    }
    if (people === 3) {
        startAmount = 58;
        indexAmount = 300;
    }
    if (people === 4) {
        startAmount = 158;
        indexAmount = 200;
    }
    if (people === 5) {
        startAmount = 39;
        indexAmount = 100;
    }
    return startAmount + index * indexAmount + addon;
}


const $a1a079905a24a014$export$51ea0f9ef65af7b4 = 457310;
function $a1a079905a24a014$export$2e2bcd8739ae039(wages, people) {
    let start = 150000;
    let addon = 0;
    let index = -1;
    if (wages < 9999) wages *= 100;
    if (people === 1) start = 206000;
    if (people === 2) start = 237000;
    if (people === 3) start = 268000;
    if (people === 4) start = 300000;
    if (people === 5) start = 331000;
    if (wages > $a1a079905a24a014$export$51ea0f9ef65af7b4) {
        addon = wages - $a1a079905a24a014$export$51ea0f9ef65af7b4;
        wages = $a1a079905a24a014$export$51ea0f9ef65af7b4;
    }
    while(wages >= start){
        start += 1000;
        index++;
    }
    if (index === -1) return 0;
    let startAmount = 578;
    let indexAmount = 700;
    if (people === 1) {
        startAmount = 341;
        indexAmount = 500;
    }
    if (people === 2) {
        startAmount = 162;
        indexAmount = 400;
    }
    if (people === 3) {
        startAmount = 38;
        indexAmount = 300;
    }
    if (people === 4) {
        startAmount = 170;
        indexAmount = 200;
    }
    if (people === 5) {
        startAmount = 57;
        indexAmount = 100;
    }
    return startAmount + index * indexAmount + addon;
}


const $68a4e3b70b3bc192$export$51ea0f9ef65af7b4 = 476699;
function $68a4e3b70b3bc192$export$2e2bcd8739ae039(wages, people) {
    let start = 156000;
    let addon = 0;
    let index = -1;
    if (wages < 9999) wages *= 100;
    if (people === 1) start = 215000;
    if (people === 2) start = 247000;
    if (people === 3) start = 280000;
    if (people === 4) start = 312000;
    if (people === 5) start = 345000;
    if (wages > $68a4e3b70b3bc192$export$51ea0f9ef65af7b4) {
        addon = wages - $68a4e3b70b3bc192$export$51ea0f9ef65af7b4;
        wages = $68a4e3b70b3bc192$export$51ea0f9ef65af7b4;
    }
    while(wages >= start){
        start += 1000;
        index++;
    }
    if (index === -1) return 0;
    let startAmount = 350;
    let indexAmount = 700;
    if (people === 1) {
        startAmount = 489;
        indexAmount = 500;
    }
    if (people === 2) {
        startAmount = 149;
        indexAmount = 400;
    }
    if (people === 3) {
        startAmount = 231;
        indexAmount = 300;
    }
    if (people === 4) {
        startAmount = 33;
        indexAmount = 200;
    }
    if (people === 5) {
        startAmount = 56;
        indexAmount = 100;
    }
    return startAmount + index * indexAmount + addon;
}


const $0ea7912c7b218395$export$51ea0f9ef65af7b4 = 486630;
function $0ea7912c7b218395$export$2e2bcd8739ae039(wages, people) {
    let start = 159000;
    let addon = 0;
    let index = -1;
    if (wages < 9999) wages *= 100;
    if (people === 1) start = 219000;
    if (people === 2) start = 252000;
    if (people === 3) start = 286000;
    if (people === 4) start = 319000;
    if (people === 5) start = 352000;
    if (wages > $0ea7912c7b218395$export$51ea0f9ef65af7b4) {
        addon = wages - $0ea7912c7b218395$export$51ea0f9ef65af7b4;
        wages = $0ea7912c7b218395$export$51ea0f9ef65af7b4;
    }
    while(wages >= start){
        start += 1000;
        index++;
    }
    if (index === -1) return 0;
    let startAmount = 182;
    let indexAmount = 700;
    if (people === 1) {
        startAmount = 259;
        indexAmount = 500;
    }
    if (people === 2) {
        startAmount = 94;
        indexAmount = 400;
    }
    if (people === 3) {
        startAmount = 286;
        indexAmount = 300;
    }
    if (people === 4) {
        startAmount = 134;
        indexAmount = 200;
    }
    if (people === 5) {
        startAmount = 39;
        indexAmount = 100;
    }
    return startAmount + index * indexAmount + addon;
}


const $dad545c909cfec2d$var$searchParams = new URLSearchParams(decodeURI(location.search));
const $dad545c909cfec2d$var$result = document.querySelector("div.result");
let $dad545c909cfec2d$var$year;
if ($dad545c909cfec2d$var$searchParams.has("year")) $dad545c909cfec2d$var$year = $dad545c909cfec2d$var$searchParams.get("year");
else $dad545c909cfec2d$var$year = new Date() < new Date(2026, 6, 1, 0, 0, 0, 0) ? "2025" : "2026";
document.querySelector("form").addEventListener("submit", (e)=>{
    e.preventDefault();
    const wages = document.querySelector('input[name="wages"]').value;
    const people = document.querySelector('select[name="people"]').selectedIndex;
    document.querySelector(".text-wages").innerText = Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR"
    }).format(wages);
    let peopleText = people + " unterhalts&shy;berechtigten Personen";
    if (people < 2) peopleText = (people === 0 ? "keiner" : "einer") + " unterhalts&shy;berechtigten Person";
    document.querySelector(".text-people").innerHTML = peopleText;
    let x;
    if ($dad545c909cfec2d$var$year === "2021") {
        console.debug("use rules for 2021");
        x = (0, $71617cddcb043f84$export$2e2bcd8739ae039)(wages * 100, people);
    } else if ($dad545c909cfec2d$var$year === "2022") {
        console.debug("use rules for 2022");
        x = (0, $f1cf1f81a56d6fb5$export$2e2bcd8739ae039)(wages * 100, people);
    } else if ($dad545c909cfec2d$var$year === "2023") {
        console.debug("use rules for 2023");
        x = (0, $0299fb0bb1cf39c5$export$2e2bcd8739ae039)(wages * 100, people);
    } else if ($dad545c909cfec2d$var$year === "2024") {
        console.debug("use rules for 2024");
        x = (0, $a1a079905a24a014$export$2e2bcd8739ae039)(wages * 100, people);
    } else if ($dad545c909cfec2d$var$year === "2025") {
        console.debug("use rules for 2025");
        x = (0, $68a4e3b70b3bc192$export$2e2bcd8739ae039)(wages * 100, people);
    } else if ($dad545c909cfec2d$var$year === "2026") {
        console.debug("use rules for 2026");
        x = (0, $0ea7912c7b218395$export$2e2bcd8739ae039)(wages * 100, people);
    } else {
        console.error("unknown calculator");
        return;
    }
    document.querySelector(".text-seizure").innerText = Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR"
    }).format(x / 100);
    $dad545c909cfec2d$var$result.classList.remove("is-hidden");
});
(0, $4e02fd932eca500b$export$17155d18b588211a)($dad545c909cfec2d$var$searchParams); // apply customizations
0, (/*@__PURE__*/$parcel$interopDefault($dhiFF)); // reference iframe resizer once to prevent tree shaking.


//# sourceMappingURL=pfaendungsrechner.2e43920a.js.map
